import { Datasource, IDatasourceConstructor } from 'utility-ng-kernel';
import { ExamType } from './../builders/exam_type_builder';
import { IDatasource, IDatasourceReportFn, key } from 'core-ts-types';

export interface ITransferExamTypesDatasource extends Datasource<ExamType> {

}

angular.module('capability-ng-transfer')
  .service('ngTransferExamTypesDatasource', function (
    ngExamTypeBuilder: typeof ExamType,
    Datasource: IDatasourceConstructor<ExamType>
  ) {
    return new Datasource({
      builderType: ngExamTypeBuilder
    });
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/datasources/transfer_exam_types_datasource.ts